export default "__VITE_ASSET__gXu4RFAk__"